import React, {Component, createRef} from "react"
import DOMPurify from "dompurify"

class DialogBox extends Component {
    constructor(props) {
        super(props);
        this.dialogRef = createRef();
        this.firstButtonRef = createRef();
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        // Add keyboard event listener
        document.addEventListener('keydown', this.handleKeyDown);
        // Focus first button when dialog opens
        if (this.firstButtonRef.current) {
            this.firstButtonRef.current.focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown(event) {
        // Close on Escape key
        if (event.key === 'Escape') {
            event.preventDefault();
            this.props.response && this.props.response("dismiss");
            return;
        }

        // Focus trap - keep focus within dialog
        if (event.key === 'Tab' && this.dialogRef.current) {
            const focusableElements = this.dialogRef.current.querySelectorAll(
                'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
            );
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    }

    render() {
        // Sanitize HTML to prevent XSS attacks
        const sanitizedMessage = this.props.message
            ? DOMPurify.sanitize(this.props.message, { ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'br', 'p'] })
            : '';

        const titleId = 'dialog-title';
        const messageId = 'dialog-message';

        return (
            <div className={"dialogBoxContainer "+this.props.theme}>
                <div
                    className="dialogBox"
                    ref={this.dialogRef}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby={this.props.title ? titleId : undefined}
                    aria-describedby={this.props.message ? messageId : undefined}
                >
                    {this.props.title && <h2 id={titleId} style={{textAlign: "center", marginTop: "0", marginBottom: "0.5rem", display: "block"}}>{this.props.title}</h2>}
                    {this.props.message && <p id={messageId} style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: sanitizedMessage}}/>}

                    <div className="buttons" role="group" aria-label="Dialog acties">
                        { this.props.btn1Text && <button ref={this.firstButtonRef} type="button" className={"btn "+(this.props.btn1Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn1Title); }}>{this.props.btn1Text}</button> }
                        { this.props.btn2Text && <button type="button" className={"btn "+(this.props.btn2Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn2Title); }}>{this.props.btn2Text}</button> }
                        { this.props.btn3Text && <button type="button" className={"btn "+(this.props.btn3Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn3Title); }}>{this.props.btn3Text}</button> }
                    </div>
                </div>
                <div
                    style={{left: "0", zIndex: "1031"}}
                    onClick={() => { this.props.response && this.props.response("dismiss"); }}
                    className="dark-overlay"
                    aria-hidden="true"
                ></div>
            </div>

        )
    }
}

export default DialogBox